import { z } from "zod";

export const getTicketParamsSchema = z.object({
	ticketId: z.string().nonempty(),
});
